export default "__VITE_ASSET__L0rItX49__"